export default __webpack_public_path__ + "static/media/Arrow.e8b628b1.svg";